import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "@/components/home/Hero";
import Challenges from "@/components/home/Challenges";
import Capabilities from "@/components/home/Capabilities";
import Industries from "@/components/home/Industries";
import Methodology from "@/components/home/Methodology";
import Showcase from "@/components/home/Showcase";
import Insights from "@/components/home/Insights";
import { FinalCTA } from "@/components/home/Closing";
import { scrollToId } from "@/lib/scroll";

const HomePage = () => {
    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const t = setTimeout(() => scrollToId(location.hash.slice(1)), 120);
            return () => clearTimeout(t);
        }
    }, [location.hash]);

    return (
        <main>
            <Hero />
            <Challenges />
            <Capabilities />
            <Industries />
            <Methodology />
            <Showcase />
            <Insights />
            <FinalCTA />
        </main>
    );
};

export default HomePage;
